export const USER_PERMISSION = {
    SUPER_ADMIN: 'admin',
    COMPANY_ADMIN: 'slag-admin',
    STAND_ADMIN: 'stand-admin',
};
